import i18n from '../../locales/index'
import restful from '@/store/vuex'

const state = {
  ...restful.states('promote_company_staff')
}

const getters = {
  ...restful.getters('promote_company_staff')
}

const actions = {
  ...restful.actions('promote_company_staffs')
}

const mutations = {
  ...restful.mutations('promote_company_staff')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
